import type { InterestRepository } from '../repositories/interest_repository'

export class DeleteInterestUseCase {
  constructor(private readonly repository: InterestRepository) {}

  execute(id: string): Promise<void> {
    return this.repository.delete(id)
  }
}
